import React, { Fragment, Component } from "react";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Grid from "@material-ui/core/Grid";
import classnames from "classnames";
import SearchIcon from "@material-ui/icons/SearchRounded";
import ClearIcon from "@material-ui/icons/ClearRounded";
import { FoodBookLogo, PLACEHOLDER_FOOD_IMAGE } from "../../utils/Constants";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import MenuCardInSearch from "./MenuCardInSearch";
import { withRouter } from "react-router-dom";
import { withStyles, Button } from "@material-ui/core";
import { connect } from "react-redux";
import ClickAwayListener from "material-ui/internal/ClickAwayListener";
import { clearSearchText } from "../../store/actionCreators/searchText";

const styles = theme => ({
  SearchBox: {
    position: "absolute",
    top: 60,
    backgroundColor: "#fff",
    color: "#000",
    width: "45%",
    boxShadow: "4px 0px 9px rgba(0,0,0,0.5)",
    borderRadius: "0 0 5px 5px",
    height: "400px",
    overflow: "auto",
    [theme.breakpoints.down("sm")]: {
      position: "fixed",
      top: 64,
      left: 0,
      bottom: 0,
      color: "#000",
      width: "100%",
      height: "auto",
      right: 0,
      backgroundColor: "#fff",
      color: "#000"
    }
  },
  restImage: {
    width: "30px",
    height: "30px",
    [theme.breakpoints.down("sm")]: {
      width: "20px",
      height: "20px"
    }
  },
  menuItemCard: {},
  warning: {
    position: "relative",
    top: "35%",
    left: "45%",
    [theme.breakpoints.down("sm")]: {
      left: "45%"
    }
  },
  loading: {
    position: "relative",
    top: "40%",
    left: "38%",
    [theme.breakpoints.down("sm")]: {
      left: "35%"
    }
  },
  restaurantName: {
    backgroundColor: "#f5f5f5",
    padding: "6px",
    fontSize: "1rem",
    [theme.breakpoints.down("sm")]: {
      padding: "10px"
    },
    fontWeight: "bold"
  },
  restaurant: {
    backgroundColor: "#fdfdfd",
    borderRadius: "5px"
  },
  restImageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      justifyContent: "flex-start"
    }
  },
  buttonMargin: {
    marginRight: "2.5rem",
    [theme.breakpoints.down("sm")]: {
      marginRight: 0
    }
  },
  viewMenu: {
    marginRight: "5px",
    fontSize: "10px",
    color: "#F37021"
  },
  marginLeft: {
    marginLeft: "10px",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "5px"
    }
  }
});

class GlobalSearch extends Component {
  defaultMessage = "Enter three or more characters";
  state = {
    loader: true,
    warning: this.defaultMessage,
    showResultBox: false,
    results: []
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.searchText === this.props.searchText) {
      return;
    }

    if (nextProps.searchText.length < 3) {
      document.body.style.overflow = "auto";
      this.setState({
        loader: true,
        warning: this.defaultMessage,
        showResultBox: false,
        results: []
      });
    } else if (nextProps.searchText.length > 2) {
      document.body.style.overflow = "hidden";
      this.setState(
        {
          loader: true,
          warning: "",
          showResultBox: true
        },
        () => {
          this.createData(nextProps.searchText);
        }
      );
    }
  }

  mapItem = (item, headers) => {
    const returnObj = {};
    headers.forEach((el, index) => {
      returnObj[el] = item[index];
    });
    return returnObj;
  };

  createData = searchText => {
    const results = this.props.searchData
      .map(restaurant => ({
        id: restaurant.id,
        name: restaurant.name,
        image: restaurant.image,
        items: restaurant.items.filter(el =>
          el.foodname
            .toLowerCase()
            .trim()
            .includes(searchText.toLowerCase().trim())
        ),
        preorder: restaurant.preorder
      }))
      .filter(el => el.items.length)
      .filter(el => {
        if (Object.keys(this.props.preorderData).length) {
          return el.preorder;
        }
        return true;
      });
    this.setState({
      loader: false,
      results
    });
  };

  render() {
    const {
      searchBarShow,
      showLocation,
      searchText,
      searchTextOnChange,
      clearSearch,
      classNames,
      classes,
      showLogo,
      searchItemClick,
      searchDataLoading
    } = this.props;
    const { SearchBox, Underline, Center, LocationText } = classNames;
    const { warning, loader, showResultBox, results } = this.state;
    return (
      <Fragment>
        {" "}
        {searchBarShow && (
          <Grid item xs style={{ position: "relative" }}>
            <TextField
              autoFocus
              value={searchText}
              placeholder="Search Item"
              className={classnames(SearchBox, Center)}
              onChange={searchTextOnChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    className={classNames.adornment}
                  >
                    <SearchIcon className={classNames.InputIcon} />
                  </InputAdornment>
                ),
                endAdornment: (
                  <React.Fragment>
                    {searchBarShow ? (
                      <InputAdornment
                        position="end"
                        onClick={clearSearch}
                        className={classNames.adornment}
                      >
                        <ClearIcon className={classNames.InputIcon} />
                      </InputAdornment>
                    ) : null}
                  </React.Fragment>
                ),
                classes: {
                  input: SearchBox,
                  underline: Underline
                }
              }}
            />
          </Grid>
        )}
        {showResultBox && (
          <ClickAwayListener onClickAway={clearSearch}>
            <Grid container item className={classes.SearchBox}>
              {!warning && searchDataLoading && (
                <Grid className={classes.warning}>
                  <Typography variant="body2">
                    <CircularProgress />
                  </Typography>
                </Grid>
              )}
              {!searchDataLoading && results.length > 0 && (
                <Grid container direction="column">
                  {results.map(restaurant => (
                    <Grid
                      container
                      direction="column"
                      className={classes.restaurant}
                    >
                      <Grid
                        container
                        item
                        className={classes.restaurantName}
                        direction="row"
                        justify="space-between"
                      >
                        <Grid
                          item
                          className={`${classes.restImageContainer} ${classes.marginLeft}`}
                        >
                          <img
                            src={restaurant.image}
                            alt=""
                            className={classes.restImage}
                          />
                          <Typography
                            variant="h6"
                            className={classes.marginLeft}
                          >
                            {restaurant.name}
                          </Typography>
                        </Grid>

                        <Grid item className={classes.buttonMargin}>
                          <Button
                            color="primary"
                            onClick={() => {
                              this.props.clearSearchText();
                              this.props.history.push(
                                "/restaurant/" + restaurant.id
                              );
                            }}
                            className={classes.viewMenu}
                          >
                            View Menu
                          </Button>
                        </Grid>
                      </Grid>
                      <Grid container item spacing={2} direction="column">
                        {restaurant.items.map(item => (
                          <Grid item className={classes.menuItemCard}>
                            <MenuCardInSearch
                              item={item}
                              onClick={searchItemClick}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              )}
              {results.length === 0 && !searchDataLoading && (
                <Typography variant="body2" className={classes.loading}>
                  No items found
                </Typography>
              )}
            </Grid>
          </ClickAwayListener>
        )}
      </Fragment>
    );
  }
}
const mapStateToProps = state => ({
  preorderData: state.preorderData,
  searchData: state.searchData,
  searchDataLoading: state.searchDataLoading
});

export default withRouter(
  withStyles(styles)(
    connect(mapStateToProps, { clearSearchText: clearSearchText })(GlobalSearch)
  )
);



// WEBPACK FOOTER //
// ./src/components/AppBar/GlobalSearch.js